import Vue from 'vue';
import axios from 'axios';
import '../../filters';
import moment from 'moment';
import { DxTagBox } from 'devextreme-vue';
import DataSource from 'devextreme/data/data_source';
import {
  DxDataGrid,
  DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
} from 'devextreme-vue/data-grid';

const PouchDB = require('pouchdb').default;

const stageDef = {
  Reconnections: { name: 'Reconnections', type: 5 },
  Disconnections: { name: 'Disconnections', type: 2 }
};

export default {
  name: 'Dms',
  components: {
    DisconnectionComp: require('./dm.vue').default,
    DxTagBox,
    DxColumn,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DmsSmsComp: require('./dmsSms.vue').default,
  },
  data: function () {
    return {
      isFieldWorker: false,
      meterReadingMandatoryCapturePhotoDm: false,
      displaySendSmsDialog: false,
      conns: [],
      editingDisconnection: {},
      editingReconnection: {},
      editingTitle: '',
      groups: [],
      projects: [],
      disBatches: [],
      reBatches: [],
      allBatches: [],
      statuses: [],
      message: '',
      showFilters: false,
      editButtons: [{
        hint: 'View',
        icon: 'search',
        visible: true,
        onClick: this.viewRecord
      }],
      filterBuilderPopupPosition: {
        of: window,
        at: 'top',
        my: 'top',
        offset: { y: 10 }
      },
      dueAmountHeaderFilters: [{
        text: 'Less than 1000',
        value: ['currentDueAmount', '<', 1000]
      }, {
        text: '1000 - 2000',
          value: [['currentDueAmount', '>=', 1000], ['currentDueAmount', '<', 2000]]
      }, {
        text: '2000 - 3000',
          value: [['currentDueAmount', '>=', 2000], ['currentDueAmount', '<', 3000]]
      }, {
        text: '3000 - 5000',
          value: [['currentDueAmount', '>=', 3000], ['currentDueAmount', '<', 5000]]
      }, {
        text: 'Greater than 5000',
          value: ['currentDueAmount', '>=', 5000]
      }],
      search: '',
      options: { pageSize: 10, total: 0, page: 1, from: null, to: null },
      billingGroupId: '-1',
      projectId: -1,
      batchId: -1,
      statusId: 1,
      bDisconnections: false,
      bReconnections: false,
      bAutoExpand: true,
      bGroupPanel: true,
      bColumnReordering: true,
      bPagination: true,
      bIsAllowDisconReconWithoutReading: false,
      bIsRemoveInstallMeter: false,
      showDisconnection: false,
      totalRow: 0,
      columnBook: { id: 0, name: this.$t('disconnections.Book'), visible: true },
      columnType: { id: 1, name: this.$t('disconnections.Type'), visible: true },
      columnAccount2: { id: 2, name: this.$t('disconnections.Account2'), visible: true },
      columnPropertyNo: { id: 3, name: this.$t('disconnections.PropertyNo'), visible: true },
      columnCustomer: { id: 4, name: this.$t('disconnections.Customer'), visible: true },
      columnAddress: { id: 5, name: this.$t('disconnections.Address'), visible: true },
      columnBalance: { id: 6, name: this.$t('disconnections.Balance'), visible: true },
      columnMeterSerialNo: { id: 7, name: this.$t('disconnections.MeterSerialNo'), visible: true },
      columnPreviousReading: { id: 8, name: this.$t('disconnections.PreviousReading'), visible: true },
      columnLastPaymentDate: { id: 9, name: this.$t('disconnections.LastPaymentDate'), visible: true },
      columnFinalReadingDate: { id: 10, name: this.$t('disconnections.FinalReadingDate'), visible: true },
      columnFinalReading: { id: 11, name: this.$t('disconnections.FinalReading'), visible: true },
      columnBatch2: { id: 12, name: this.$t('disconnections.Batch2'), visible: true },
      columns: [],
      fields: {},
      selectedFields: [],
      geoLocation: null,
      gMapPosition: { lat: 0, lng: 0 },
      coordAccuracy: 0,
      localDb: null,
      bWorkOffline: false,
      offlineConns: [],
      bConfirmResetDialog: false,
      bConfirmSyncDialog: false,
      cellTelNo: '',
    }
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    },
    selectedFieldsCount: function () {
      return this.selectedFields.length;
    },
    formatCurrency: function () {
      let cur = '€';
      if (this.$store.state.settings.currencySymbol != null)
        cur = this.$store.state.settings.currencySymbol; 
      else
        cur = '€';
       
      return cur + " #,##0.##";
    },
    bookWalkCount: function () {      
      let temp = [];
      this.conns.forEach(c => temp.push(c.bookWalk));
      return new Set(temp).size;
    },
    totalRunningBalance: function () {
      let cur = '€';
      let temp = 0;

      if (this.$store.state.settings.currencySymbol != null) 
        cur = this.$store.state.settings.currencySymbol;
      else
        cur = '€';

      this.conns.forEach(c => temp = temp + c.currentDueAmount);

      return cur + ' ' + new Intl.NumberFormat().format(temp);
    }
  },
  watch: {
    languageLocale: function (value) {
      this.columnBook.name = this.$t('disconnections.Book');
      this.columnType.name = this.$t('disconnections.Type');
      this.columnAccount2.name = this.$t('disconnections.Account2');
      this.columnPropertyNo.name = this.$t('disconnections.PropertyNo');
      this.columnCustomer.name = this.$t('disconnections.Customer');
      this.columnAddress.name = this.$t('disconnections.Address');
      this.columnBalance.name = this.$t('disconnections.Balance');
      this.columnMeterSerialNo.name = this.$t('disconnections.MeterSerialNo');
      this.columnPreviousReading.name = this.$t('disconnections.PreviousReading');
      this.columnLastPaymentDate.name = this.$t('disconnections.LastPaymentDate');
      this.columnFinalReadingDate.name = this.$t('disconnections.FinalReadingDate');
      this.columnFinalReading.name = this.$t('disconnections.FinalReading');
      this.columnBatch2.name = this.$t('disconnections.Batch2');
    },
    selectedFieldsCount: function () {
      var iCount = this.selectedFields;
    },
    search: function (value) {
      this.getRecords();
    },
    billingGroupId: function (value) {
      this.getRecords();
    },
    projectId: function (value) {
      this.getRecords();
    },
    batchId: function (value) {
      this.getRecords();
    },
    statusId: function (value) {
      this.getRecords();
    },
    bPagination: function (value) {
      this.getRecords();
    },
    bDisconnections: function (value) {
      if ((value === true) && (this.bReconnections === false))
        this.getDisconnections();
      if ((value === false) && (this.bReconnections === true))
        this.getReconnections();
      if ((value === true) && (this.bReconnections === true))
        this.getMixconnections();
      if ((value === false) && (this.bReconnections === false))
        this.conns = [];
    },
    bReconnections: function (value) {
      if ((value === true) && (this.bDisconnections === false))
        this.getRecords();
      if ((value === false) && (this.bDisconnections === true))
        this.getDisconnections();
      if ((value === true) && (this.bDisconnections === true))
        this.getMixconnections();
      if ((value === false) && (this.bDisconnections === false))
        this.conns = [];
    },
    bWorkOffline: function (value) {
      if (value) {
        // this.setOfflineData();
      }
    }
  },
  created() {
    if (this.$store.state.userProfile.portalDm != true)
      this.$router.push('/employeeHome');

    //change in app.ts L568, dashboards.ts L294 and dms.ts L250
    if (this.$store.state.userProfile.isFieldWorker == true)
      this.$router.push('/debtManagementSelectBatch');

    this.isFieldWorker = this.$store.getters.getUserProfile.isFieldWorker ?? false;

    this.$root.$on('close_dms_send_sms_dialog', this.sendSmsDialog);
    this.localDb = new PouchDB('DebtManagement');
    this.localDb.info().then(function (info) {
      //console.log('localDb.info');
      //console.log('============');
      //console.log(info);
    });
    this.getAllRecords();
    this.selectedFields = [0, 1, 2, 3, 4];
    this.columns = [
      this.columnBook.name,
      this.columnType.name,
      this.columnAccount2.name,
      this.columnPropertyNo.name,
      this.columnCustomer.name,
      this.columnAddress.name,
      this.columnBalance.name,
      this.columnMeterSerialNo.name,
      this.columnPreviousReading.name,
      this.columnPreviousReading.name,
      this.columnLastPaymentDate.name,
      this.columnFinalReadingDate.name,
      this.columnFinalReading.name,
      this.columnBatch2.name,
    ];
    this.fields = new DataSource({
      store: [
        this.columnBook,
        this.columnType,
        this.columnAccount2,
        this.columnPropertyNo,
        this.columnCustomer,
        this.columnAddress,
        this.columnBalance,
        this.columnMeterSerialNo,
        this.columnPreviousReading,
        this.columnPreviousReading,
        this.columnLastPaymentDate,
        this.columnFinalReadingDate,
        this.columnFinalReading,
        this.columnBatch2,
      ],
      key: 'id',
    });
    this.getDmActivityPropertyStatuses();
    this.getBillingGroups();
    this.getProjects();
    this.getDisconnectionBatches();
    this.getReconnectionBatches();
    this.getAllBatches();
    this.getSettings();

    var geoOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    var geo = navigator.geolocation.getCurrentPosition(
      (pos) => { this.geoLocation = pos; this.addGeoLocation(); },
      (err) => { this.$alertMsg(err.message); },
      geoOptions
    );
  },
  methods: {
    sendSmsDialog() {
      this.displaySendSmsDialog = !this.displaySendSmsDialog;
    },
//*** PouchDb Functions **//
    SyncAllData() {
      const syncOfflineRecords = this.offlineConns;
      syncOfflineRecords.forEach(syncItem => this.transferSyncRecord(syncItem));
    },
    transferSyncRecord(syncRec) {
      var parameter = null;
      if (syncRec.status !== 3 && syncRec.isUnderInvestigation !== true && syncRec.onlyComments !== true) {
        if (syncRec.bInvalid === true)
          return;

        parameter = {
          Account: syncRec.account,
          CaseId: syncRec.caseId,
          ConnectionId: syncRec.connectionId,
          FinalReading: syncRec.finalReading,
          FinalReadingDate: syncRec.finalReadingDate,
          FinalReadingClockOver: syncRec.finalReadingClockOver,
          Comment: syncRec.comment,
          SkipMeterReading: (syncRec.finalReading == null || syncRec.finalReading == 0 || syncRec.finalReading == '0') &&
            syncRec.isAllowDisconReconWithoutReading == true ? true : false,
          RemoveMeter: syncRec.removeMeter,
          InstallMeterId: syncRec.removeMeter === false ? 0 : syncRec.meterId
        };

        //var sDay = moment(parameter.FinalReadingDate).format('D');
        //var sMonth = moment(parameter.FinalReadingDate).format('M');
        //var sYear = moment(parameter.FinalReadingDate).format('YYYY');

        if (parameter.FinalReadingDate === null)
          parameter.FinalReadingDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
        else
          parameter.FinalReadingDate = moment(parameter.FinalReadingDate);
          //parameter.FinalReadingDate = new Date(parseInt(sYear), parseInt(sMonth), parseInt(sDay) + 1);

        if (parameter.FinalReadingClockOver === null)
          parameter.FinalReadingClockOver = false;

        var sFunction = syncRec.stage === 5 ? 'SetReconnectionFinalReading' : 'SetDisconnectionFinalReading';

        this.$store.state.notifier.asyncBlock(
          axios.post('/DmConnection/' + sFunction, parameter),
          resp => {
            if (resp.data.data.status == 0) {
              this.$alertMsg(this.$t('common.SyncRecordSuccessful'), 2);
              this.removeSyncRecord(syncRec);
            }
            else
              this.$alertMsg(resp.data.data.text);
          },
          err => {
            this.$alertMsg(err.response.data);
          },
          "Syncing record to backend"
        );

      } else if (syncRec.onlyComments === true) {
        parameter = {
          Account: syncRec.account,
          CaseId: syncRec.caseId,
          ConnectionId: syncRec.connectionId,
          Comment: syncRec.comment,
        };
        var sFunction = syncRec.stage === stageDef.Disconnections.type ? 'SetDisconnectionComment' : 'SetReconnectionComment';

        this.$store.state.notifier.asyncBlock(
          axios.post('/DmConnection/' + sFunction, parameter),
          resp => {
            if (resp.data.data.status == 0) {
              this.$alertMsg(this.$t('common.SyncRecordSuccessful'), 2);
              this.removeSyncRecord(syncRec);
            }
            else
             this.$alertMsg(resp.data.data.text);
          },
          err => {
            this.$alertMsg(err.response.data);
          },
          "Syncing record to backend"
        );
      }
      else {
        parameter = {
          Account: syncRec.account,
          CaseId: syncRec.caseId,
          ConnectionId: syncRec.connectionId,
          Comment: syncRec.comment,
        };
        var sFunction = syncRec.removeFromInvestigation === true ? 'RemoveFromInvestigation' : 'PutUnderInvestigation';

        this.$store.state.notifier.asyncBlock(
          axios.post('/DmConnection/' + sFunction, parameter),
          resp => {
            if (resp.data.data.status == 0) {
              var sMsgInvestigation = this.$t('common.SyncRecordSuccessful') + (syncRec.removeFromInvestigation === true ? this.$t('messages.DisconnSuccessRemovedInvestigation') : this.$t('messages.DisconnSuccessSetUnderInvestigation'));
              this.$alertMsg(sMsgInvestigation, 0);
              this.removeSyncRecord(syncRec);
            }
            else
             this.$alertMsg(resp.data.data.text);
          },
          err => {
            this.$alertMsg(err.response.data);
          },
          "Syncing record to backend"
        );

      }
    },
    removeSyncRecord(syncRec) {
      this.localDb.remove(syncRec).then((resultRemove) => {
        console.log(resultRemove);
        this.getAllRecords();
      }).catch((err) => {
        console.log(err);
      });
    },
    resetSyncData() {
      this.localDb.destroy().then((response) => {
        console.log(response);
        this.localDb = new PouchDB('DebtManagement');
        this.localDb.info().then((info) => {
          console.log('localDb.info');
          console.log('============');
          console.log(info);
          this.getAllRecords();
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    getAllRecords() {
      this.localDb.allDocs({
        include_docs: true
      }).then((result) => {
        this.offlineConns = [];
        result.rows.forEach(item => this.offlineConns.push(item.doc));
      }).catch((err) => {
        console.log(err);
      });
    },
    setPouchRecord(syncAction, syncParameter, syncFunction) {
      this.editingDisconnection._id = this.editingDisconnection.account + '-' + this.editingDisconnection.caseId + '-' + this.editingDisconnection.connectionId;
      this.editingDisconnection.syncAction = syncAction;
      this.editingDisconnection.syncParameter = syncParameter;
      this.editingDisconnection.syncFunction = syncFunction;
      this.localDb.get(this.editingDisconnection._id).then((doc) => {
        this.editingDisconnection._rev = doc._rev;
        this.localDb.put(this.editingDisconnection).then((resultPut) => {
          console.log(resultPut);
          this.getAllRecords();
        }).catch((err) => {
          console.log(err);
        });
      }).catch((err) => {
        console.log(err);
        this.localDb.put(this.editingDisconnection).then((resultPut) => {
          console.log(resultPut);
          this.getAllRecords();
        }).catch((err) => {
          console.log(err);
        });
      });
    },
//*** End of - PouchDb Functions **//
    addGeoLocation() {
      if (this.geoLocation != null) {
        this.coordAccuracy = this.geoLocation.coords.accuracy;
        this.gMapPosition.lat = this.geoLocation.coords.latitude;
        this.gMapPosition.lng = this.geoLocation.coords.longitude;
      }
      else {
        this.coordAccuracy = 0;
        this.gMapPosition.lat = 0;
        this.gMapPosition.lng = 0;
      }
    },
    setGpsLocation(editingConnection) {
      var parameter = {
        Account: editingConnection.account,
        CaseId: editingConnection.caseId,
        ConnectionId: editingConnection.connectionId,
        CoordLat: this.gMapPosition.lat,
        CoordLong: this.gMapPosition.lng,
        CoordAccuracy: this.coordAccuracy
      };
      var sFunctionName = editingConnection.stage === stageDef.Disconnections.type ? 'SetDisconnectionLocation' : 'SetReconnectionLocation';
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/' + sFunctionName, parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            setTimeout(() => {
              this.$alertMsg(this.$t('messages.GpsLocationSetSuccess'), 2);
            }, 2000);
            
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getSettings() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetSettings')
        .then(response => {

          if (response.data.data.status == 0) {
            this.bIsAllowDisconReconWithoutReading = response.data.value.isAllowDisconReconWithoutReading;
            this.bIsRemoveInstallMeter = response.data.value.isRemoveInstallMeter;
            this.meterReadingMandatoryCapturePhotoDm = response.data.value.meterReadingMandatoryCapturePhotoDm;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    calculateCellClass(value) {
      return value === 2 ? 'recordTypeDisconnection' : 'recordTypeReconnection';
    },
    calculateCellValue(data) {
      return data.stage === 2 ? 'Disconnection' : 'Reconnection';
    },
    getRecords() {
      if ((this.bDisconnections === true) && (this.bReconnections === false))
        this.getDisconnections();
      if ((this.bDisconnections === false) && (this.bReconnections === true))
        this.getReconnections();
      if ((this.bDisconnections === true) && (this.bReconnections === true))
        this.getMixconnections();
      if ((this.bDisconnections === false) && (this.bReconnections === false))
        this.conns = [];
    },
    getRecordsAux(parameter) {
      if ((this.bDisconnections === true) && (this.bReconnections === false))
        this.getDisconnectionsAux(parameter);
      if ((this.bDisconnections === false) && (this.bReconnections === true))
        this.getReconnectionsAux(parameter);
      if ((this.bDisconnections === true) && (this.bReconnections === true))
        this.getMixconnectionsAux(parameter);
      if ((this.bDisconnections === false) && (this.bReconnections === false))
        this.conns = [];
    },
    handleValueChanged(event) {
      this.selectedFields = event.value;
    },
    columnVisible(col) {
      return this.selectedFields.indexOf(col.id) > -1;
    },
    pageChange(pInfo) {
      var parameter = {
        Options: {
          PageSize: pInfo.pageSize,
          Page: pInfo.pageNumber,
          FilterText: this.search
        },
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        BatchNo: this.batchId,
        Status: this.statusId
      };
      this.getRecordsAux(parameter);
    },
    getMixconnectionsAux(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetMixConnectionItems', parameter)
        .then(response => {
          this.handleConnectionResponse(response);

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getMixconnections() {
      var parameter = {
        Options: {
          PageSize: this.bPagination===true? this.options.pageSize: 10000,
          Page: this.options.page,
          FilterText: this.search
        },
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        BatchNo: this.batchId,
        Status: this.statusId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetMixConnectionItems', parameter)
        .then(response => {
          this.handleConnectionResponse(response);

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getDisconnectionsAux(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetDisconnectionItems', parameter)
        .then(response => {
          this.handleConnectionResponse(response);        

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getDisconnections() {
      var parameter = {
        Options: {
          PageSize: this.bPagination === true ? this.options.pageSize : 10000,
          Page: this.options.page,
          FilterText: this.search
        },
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        BatchNo: this.batchId,
        Status: this.statusId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetDisconnectionItems', parameter)
        .then(response => {
          this.handleConnectionResponse(response);

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getReconnections() {
      var parameter = {
        Options: {
          PageSize: this.bPagination === true ? this.options.pageSize : 10000,
          Page: this.options.page,
          FilterText: this.search
        },
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        BatchNo: this.batchId,
        Status: this.statusId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetReconnectionItems', parameter)
        .then(response => {
          this.handleConnectionResponse(response);

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    getReconnectionsAux(parameter) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/GetReconnectionItems', parameter)
        .then(response => {
          this.handleConnectionResponse(response);

          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
        })
    },
    handleConnectionResponse(response) {
      if (response.data.data.status == 0) {
        response.data.items.forEach((item) => {
          item.recordType = item.stage === 2 ? 'Disconnection' : 'Reconnection';
          item.rowClass = 'disconnections';
          item.statusText = item.status === 1 ? 'Assigned' : item.status === 2 ? 'Processed' : item.status === 3 ? 'Under Investigation' : 'None';

          if (item.isUnderInvestigation == true)
            item.rowClass = 'investigation';

          if (item.finalReading > 0)
            item.rowClass = 'completed';
        });
        this.conns = response.data.items;
        this.options.total = response.data.count;
        this.totalRow = response.data.count;
      }
      else {
        this.$alertMsg(response.data.data.text);
        this.options.total = 0;
      }
    },
    getDmActivityPropertyStatuses() {
      axios.post('/DmConnection/GetDmActivityPropertyStatuses')
        .then(response => {
          if (response.data.data.status == 0) {
            this.statuses = response.data.items;
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getBillingGroups() {
      axios.post('/DmConnection/GetBillingGroups')
        .then(response => {
          if (response.data.data.status == 0) {
            this.groups = response.data.items;
            this.groups.unshift({ id: '-1', name: 'ALL' });
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getProjects() {
      axios.post('/DmConnection/GetProjects')
        .then(response => {
          if (response.data.data.status == 0) {
            this.projects = response.data.items;
            this.projects.unshift({ id: '-1', name: 'ALL' });
            this.projectId = '-1';
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getDisconnectionBatches() {
      var parameter = {
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        Status: this.statusId
      };
      axios.post('/DmConnection/GetDisconnectionBatches', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.disBatches = response.data.items;
            this.disBatches.unshift({ id: '-1', name: 'ALL' });
            this.batchId = '-1';
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getReconnectionBatches() {
      var parameter = {
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        Status: this.statusId
      };
      axios.post('/DmConnection/GetReconnectionBatches', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.reBatches = response.data.items;
            this.reBatches.unshift({ id: '-1', name: 'ALL' });
            this.batchId = '-1';
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    getAllBatches() {
      var parameter = {
        BillingGroupId: (this.billingGroupId == '-1' ? '' : this.billingGroupId),
        ProjectId: this.projectId,
        Status: this.statusId
      };
      axios.post('/DmConnection/GetAllBatches', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.allBatches = response.data.items;
            this.allBatches.unshift({ id: '-1', name: 'ALL' });
            this.batchId = '-1';
          }
          else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch(e => { this.$router.push('/login'); return false; })
    },
    viewRecord(data) {
      this.editingDisconnection = this.conns.filter(item => item.account === data.row.data.account && item.caseId === data.row.data.caseId && item.connectionId === data.row.data.connectionId)[0];
      this.editingDisconnection.isAllowDisconReconWithoutReading = this.bIsAllowDisconReconWithoutReading;
      this.editingDisconnection.isRemoveInstallMeter = this.bIsRemoveInstallMeter;
      this.editingDisconnection.removeMeter = false;
      this.editingDisconnection.installMeter = false;
      this.editingDisconnection.onlyComments = false;
      this.editingDisconnection.meterReadingMandatoryCapturePhotoDm = this.meterReadingMandatoryCapturePhotoDm;
      this.editingDisconnection.installMeterId = this.editingDisconnection.installMeterId && this.editingDisconnection.installMeterId > -1 ? this.editingDisconnection.installMeterId: -1;
      
      this.editingTitle = this.editingDisconnection.stage === stageDef.Disconnections.type ? this.$t('disconnections.EditDisconnection') : this.$t('disconnections.EditReconnection');
      this.editingTitle = this.editingTitle + ', ' + this.editingDisconnection.bookWalk;
      this.editingDisconnection.finalReadingDateAux = this.editingDisconnection.finalReadingDate;
      this.editingDisconnection.readonly = false;
      this.$root.$emit('disconnection_updated');
      this.showDisconnection = true;
    },
    editDisconnection(disconnection) {
      this.editingTitle = disconnection.stage === stageDef.Disconnections.type ? this.$t('disconnections.EditDisconnection') : this.$t('disconnections.EditReconnection');
      this.editingDisconnection = disconnection;
      this.editingDisconnection.finalReadingDateAux = this.editingDisconnection.finalReadingDate;
      this.editingDisconnection.readonly = false;
      this.$root.$emit('disconnection_updated');
      this.showDisconnection = true;
    },
    putUnderInvestigation() {
      var parameter = {
        Account: this.editingDisconnection.account,
        CaseId: this.editingDisconnection.caseId,
        ConnectionId: this.editingDisconnection.connectionId
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/PutUnderInvestigation', parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.DisconnSuccessSetUnderInvestigation'), 2);
          }
          else
            this.$alertMsg(response.data.data.text);

          loader.hide();
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    checkIfPhotoUploaded() {
      if (this.isUnderInvestigation == true || this.onlyComments == true ||
        this.meterReadingMandatoryCapturePhotoDm != true )
        return true;

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      return axios.post('/DmConnection/GetAttachments',
        {
          Account: this.editingDisconnection.account,
          CaseId: this.editingDisconnection.caseId
        })
        .then(resp => {
          if (resp.status == 200 && resp.data.data.status == 0) {
            let attachments = resp.data.items;

            if (attachments == null || attachments.length == 0) {
              this.$alertMsg(this.$t('messages.CapturePhotoAlert'));
              loader.hide();
              return false;
            }

            loader.hide();
            return true;
          }
          else {
            loader.hide();
            return false;
          }
        })
        .catch(err => {
          loader.hide();
          console.log("err", err);
          return false;
        });
    },
    async save() {
      if (this.isFieldWorker == true && await this.checkIfPhotoUploaded() == false) {
        return;
      }
      if (this.bWorkOffline === false) {
        this.setGpsLocation(this.editingDisconnection);
        if (this.editingDisconnection.status !== 3 && this.editingDisconnection.isUnderInvestigation !== true && this.editingDisconnection.onlyComments !== true) {
          this.saveDisconnection();
        }
        else if (this.editingDisconnection.onlyComments === true) {
          var parameter = {
            Account: this.editingDisconnection.account,
            CaseId: this.editingDisconnection.caseId,
            ConnectionId: this.editingDisconnection.connectionId,
            Comment: this.editingDisconnection.comment,
          };
          var sFunction = this.editingDisconnection.stage === stageDef.Disconnections.type ? 'SetDisconnectionComment' : 'SetReconnectionComment';
          let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
          axios.post('/DmConnection/' + sFunction, parameter)
            .then(response => {
              if (response.data.data.status == 0) {
                this.$alertMsg(this.$t('messages.RecordSavedSuccess'), 2);
              }
              else
                this.$alertMsg(response.data.data.text);

              loader.hide();
              this.showDisconnection = false;
            })
            .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
        }
        else {
          var parameter = {
            Account: this.editingDisconnection.account,
            CaseId: this.editingDisconnection.caseId,
            ConnectionId: this.editingDisconnection.connectionId,
            Comment: this.editingDisconnection.comment,
          };
          var sFunction = this.editingDisconnection.removeFromInvestigation === true ? 'RemoveFromInvestigation' : 'PutUnderInvestigation';

          let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
          axios.post('/DmConnection/' + sFunction, parameter)
            .then(response => {
              if (response.data.data.status == 0) {
                var sMsgInvestigation = this.editingDisconnection.removeFromInvestigation === true ? this.$t('messages.DisconnSuccessRemovedInvestigation') : this.$t('messages.DisconnSuccessSetUnderInvestigation')
                this.$alertMsg(sMsgInvestigation, 2);
                this.getRecords();
              }
              else
                this.$alertMsg(response.data.data.text);

              loader.hide();
              this.showDisconnection = false;
            })
            .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
        }
        //this.saveDisconnection();
      } //*** OFFLINE MODE LOCAL OPERATIONS ****//
      else {
        if (this.editingDisconnection.status !== 3 && this.editingDisconnection.isUnderInvestigation !== true && this.editingDisconnection.onlyComments !== true) {
          if (this.editingDisconnection.bInvalid === true)
            return;

          this.showDisconnection = false;

          var parameterOffline1 = {
            Account: this.editingDisconnection.account,
            CaseId: this.editingDisconnection.caseId,
            ConnectionId: this.editingDisconnection.connectionId,
            FinalReading: this.editingDisconnection.finalReading,
            FinalReadingDate: this.editingDisconnection.finalReadingDate,
            FinalReadingClockOver: this.editingDisconnection.finalReadingClockOver,
            Comment: this.editingDisconnection.comment,
            SkipMeterReading: (this.editingDisconnection.finalReading == null || this.editingDisconnection.finalReading == 0 || this.editingDisconnection.finalReading == '0') &&
               this.editingDisconnection.isAllowDisconReconWithoutReading == true ? true : false,
            RemoveMeter: this.editingDisconnection.removeMeter,
            InstallMeterId: this.editingDisconnection.removeMeter === false ? 0 : this.editingDisconnection.meterId
          };

          if (parameterOffline1.FinalReadingDate === null)
            parameterOffline1.FinalReadingDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
          else
            parameterOffline1.FinalReadingDate = new Date(parameterOffline1.FinalReadingDate.getFullYear(), parameterOffline1.FinalReadingDate.getMonth(), parameterOffline1.FinalReadingDate.getDate() + 1);

          if (parameterOffline1.FinalReadingClockOver === null)
            parameterOffline1.FinalReadingClockOver = false;

          var syncFunction = this.editingDisconnection.stage === 5 ? 'SetReconnectionFinalReading' : 'SetDisconnectionFinalReading';

          //*** save to PouchDb ***//
          this.setPouchRecord('Reading', parameterOffline1, syncFunction);

        } else if (this.editingDisconnection.onlyComments === true) {
          var parameterOffline2 = {
            Account: this.editingDisconnection.account,
            CaseId: this.editingDisconnection.caseId,
            ConnectionId: this.editingDisconnection.connectionId,
            Comment: this.editingDisconnection.comment,
          };
          var syncFunction = this.editingDisconnection.stage === stageDef.Disconnections.type ? 'SetDisconnectionComment' : 'SetReconnectionComment';
          //*** save to PouchDb ***//
          this.setPouchRecord('Comment', parameterOffline2, syncFunction);
        }
        else {
          var parameterOffline3 = {
            Account: this.editingDisconnection.account,
            CaseId: this.editingDisconnection.caseId,
            ConnectionId: this.editingDisconnection.connectionId,
            Comment: this.editingDisconnection.comment,
          };
          var syncFunction = this.editingDisconnection.removeFromInvestigation === true ? 'RemoveFromInvestigation' : 'PutUnderInvestigation';
          //*** save to PouchDb ***//
          this.setPouchRecord('Comment', parameterOffline3, syncFunction);
        }
      }
    },
    saveDisconnection() {
      if (this.editingDisconnection.bInvalid === true && this.bIsAllowDisconReconWithoutReading == false)
        return;

      var parameter = {
        Account: this.editingDisconnection.account,
        CaseId: this.editingDisconnection.caseId,
        ConnectionId: this.editingDisconnection.connectionId,
        FinalReading: this.editingDisconnection.finalReading,
        FinalReadingDate: this.editingDisconnection.finalReadingDate,
        FinalReadingClockOver: this.editingDisconnection.finalReadingClockOver,
        Comment: this.editingDisconnection.comment,
        SkipMeterReading: (this.editingDisconnection.finalReading == null || this.editingDisconnection.finalReading == 0 || this.editingDisconnection.finalReading == '0') &&
          this.editingDisconnection.isAllowDisconReconWithoutReading == true ? true : false,
        RemoveMeter: this.editingDisconnection.removeMeter,
        InstallMeterId: this.editingDisconnection.removeMeter === false ? 0 : this.editingDisconnection.meterId
      };

      if (parameter.FinalReadingDate === null)
        parameter.FinalReadingDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
      else
        parameter.FinalReadingDate = new Date(parameter.FinalReadingDate.getFullYear(), parameter.FinalReadingDate.getMonth(), parameter.FinalReadingDate.getDate() + 1);

      if (parameter.FinalReadingClockOver === null)
        parameter.FinalReadingClockOver = false;

      var sFunction = this.editingDisconnection.stage === 5 ? 'SetReconnectionFinalReading' : 'SetDisconnectionFinalReading';

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/DmConnection/' + sFunction, parameter)
        .then(response => {
          if (response.data.data.status == 0) {
            this.$alertMsg(this.$t('messages.DisconnSavedSuccess'), 2);
            this.editingDisconnection.finalReadingDate = parameter.FinalReadingDate;
            this.getRecords();
          }
          else
            this.$alertMsg(response.data.data.text);

          loader.hide();
          this.showDisconnection = false;
        })
        .catch((e) => { loader.hide(); this.$alertMsg(e.message); })
    },
    closeDialog() {
      this.showDisconnection = false;
    },
    onPagination(args) {
      this.options.page = args.page;
      this.options.pageSize = args.size;
      this.getRecords();
    },    
  },

}
